<template>
  <div class="layout-content">
    <u-table
      v-model="hospitalSelected"
      :headers="headers"
      :items="items"
      :mobileBreakpoint="900"
      :showSelect="false"
      itemKey="hospital_id"
      :loading="loading"
      @dbclickRow="click"
      :pagination="pagination"
      @onChangePagination="onChangePagination"
    >
      <!-- // # Header Table -->
      <template v-slot:header>
        <v-row
          :justify="priorityUser === 0 ? 'space-between' : 'end'"
          align="center"
        >
          <!-- // # Action Group -->
          <v-col cols="12" md="2" v-if="priorityUser === 0">
            <v-btn color="primary" block dark @click="dialog = !dialog">
              <v-icon>mdi-home-plus</v-icon>เพิ่ม{{ NameComponent }}
            </v-btn>
          </v-col>

          <!-- // # Search Group -->
          <v-col cols="12" md="5">
            <v-row justify="center" align="center">
              <v-col
                ><v-text-field
                  v-model="keyword"
                  name="name"
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  placeholder="ค้นหา"
                  label="ค้นหา ชื่อโรงพยาบาล"
                  id="id"
                  hide-details
                  @keyup.enter="init()"
                ></v-text-field
              ></v-col>
              <v-col cols="4">
                <v-btn color="primary" block dark @click="init()">ค้นหา</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.number`]="{ item }">
        {{
          pagination.row * pagination.page -
          pagination.row +
          (items.indexOf(item) + 1)
        }}
      </template>
      <!-- <template v-slot:[`item.phone`]="{ item }">
        {{ item.phone !== "" && item.phone !== null ? item.phone : "-" }}
      </template> -->
      <template v-slot:[`item.hcode`]="{ item }">
          {{ item.hcode !== "" && item.hcode !== null ? item.hcode : "-" }}
      </template>
      <!-- <template v-slot:[`item.province`]="{ item }">
        {{ item.province !== "" && item.province !== null ? item.province : "-" }}
      </template> -->
      <!-- <template v-slot:[`item.district`]="{ item }">
        {{ item.district !== "" && item.district !== null ? item.district : "-" }}
      </template> -->
      <template v-slot:[`item.area`]="{ item }">
        {{ item.area !== "" && item.area !== null ? item.area : "-" }}
      </template>

      <template v-slot:[`item.name`]="{ item }">
        <span class="fix-overflow-ellipsis">
          {{ item.name }}
        </span>
      </template>

      <template v-slot:[`item.description`]="{ item }">
        <span class="fix-overflow-ellipsis">
          {{
            item.description !== "" && item.description !== null
              ? item.description
              : "-"
          }}
        </span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              icon
              fab
              x-small
              dark
              color="primary"
              @click="click(item)"
            >
              <v-icon>mdi-hospital-building</v-icon>
            </v-btn>
          </template>
          <span>ดูรายละเอียด</span>
        </v-tooltip>

        <v-tooltip top v-if="priorityUser === 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              fab
              x-small
              dark
              color="primary"
              @click="editItem(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>แก้ไขข้อมูล</span>
        </v-tooltip>

        <v-tooltip top v-if="priorityUser === 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              icon
              fab
              x-small
              dark
              color="error"
              @click="deleteItem(item)"
            >
              <v-icon>mdi-delete-forever</v-icon>
            </v-btn>
          </template>
          <span>ลบ</span>
        </v-tooltip>
      </template>
    </u-table>

    <u-card-form
      :title="formTitle"
      :subtitle="formSubTitle"
      ref="form"
      v-model="dialog"
    >
      <template v-slot:form>
          <div>
            <span class="required">*</span><span>{{ NameComponent }}</span>
          </div>
          <v-text-field
            v-model="editedItem.name"
            :items="hospitals"
            :rules="[Rule.noInPut]"
            :placeholder="`กรุณากรอก${NameComponent}`"
            required
            outlined
            dense
          ></v-text-field>
        <div><span></span><span>รหัสโรงพยาบาล</span></div>
        <v-text-field
          v-model="editedItem.hcode"
          :rules="editedItem.hcode == '' ? []:[Rule.fixhcode]"
          placeholder="กรุณากรอก รหัสโรงพยาบาล"
          maxlength="5"
          outlined
          min="5"
          dense
          :disabled="loading"
          :loading="loading"
        ></v-text-field>

        <div><span></span><span>จังหวัด</span></div>
        <v-text-field
          v-model="editedItem.province"
          :rules="editedItem.province == '' ? []:[Rule.noSpecialCharacters,Rule.noSpace]"
          placeholder="กรุณากรอก จังหวัด"
          outlined
          dense
          :disabled="loading"
          :loading="loading"
        ></v-text-field>

        <div><span></span><span>อำเภอ</span></div>
        <v-text-field
          v-model="editedItem.district"
          :rules="editedItem.district == '' ? []:[Rule.noSpecialCharacters,Rule.noSpace]"
          placeholder="กรุณากรอก อำเภอ"
          outlined
          dense
          :disabled="loading"
          :loading="loading"
        ></v-text-field>

        <div><span></span><span>เขตสุขภาพ</span></div>
        <v-text-field
          v-model="editedItem.area"
          :rules="editedItem.area == '' ? []:[Rule.fixCoutingArea,Rule.numberOnly]"
          placeholder="กรุณากรอก เขตสุขภาพ"
          outlined
          dense
          :disabled="loading"
          :loading="loading"
        ></v-text-field>

        <div><span>บันทึกรายละเอียด</span></div>
        <v-textarea
          no-resize
          v-model="editedItem.description"
          outlined
          placeholder="รายละเอียด"
          value=""
        ></v-textarea>
      </template>
      <template v-slot:actions="{ valid }">
        <v-row>
          <v-col>
            <v-btn
              @click="save"
              :disabled="!valid"
              block
              color="primary"
              :loading="loadingSave"
            >
              บันทึก
            </v-btn>
          </v-col>
          <v-col
            ><v-btn block color="error" @click="close">ยกเลิก</v-btn></v-col
          >
        </v-row>
      </template>
    </u-card-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userInfo: {},
      priorityUser: '',
      NameComponent: 'โรงพยาบาล',
      dialog: false, // สำหรับใช้เปิดปิด dialog add/edit
      rules: [(v) => !!v || 'กรุณากรอกข้อมูล'],
      bizIdEdit: '',
      keyword: '',
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          sortable: false,
          value: 'number'
        },
        {
          text: 'ชื่อโรงพยาบาล',
          align: 'start',
          value: 'name',
          sortable: false
          // width: '10%'
        },
        // {
        //   text: 'เบอร์โทรศัพท์',
        //   value: 'phone',
        //   align: 'start',
        //   sortable: false,
        //   width: '10%'
        // },
        {
          text: 'รหัสโรงพยาบาล',
          value: 'hcode',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        // province
        // {
        //   text: 'จังหวัด',
        //   value: 'province',
        //   align: 'center',
        //   sortable: false,
        //   width: '10%'
        // },
        // {
        //   text: 'อำเภอ',
        //   value: 'district',
        //   align: 'center',
        //   sortable: false,
        // },
        {
          text: 'เขตสุขภาพ',
          value: 'area',
          align: 'center',
          sortable: false,
          width: '10%'
        },
        {
          text: 'รายละเอียด',
          value: 'description',
          align: 'start',
          sortable: false
        },
        {
          text: 'จัดการ',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '175px'
        }
      ],
      hospitalSelected: [],
      items: [],
      hospitals: [],
      editedIndex: -1,
      editedItem: {
        hospital_id: '',
        name: '',
        biz_id: '',
        // phone: '',
        description: '',
        hcode: '',
        province: '',
        district: '',
        area: ''
      },
      defaultItem: {
        hospital_id: '',
        name: '',
        biz_id: '',
        // phone: '',
        description: '',
        hcode: '',
        province: '',
        district: '',
        area: ''
      },
      pagination: {
        total: 0,
        page: 1,
        row: 10
      },
      loading: false,
      loadingSave: false
    }
  },
  async created () {
    await this.init()
    this.initUserInfo()
    this.$store.commit('hospitalName', '')
  },
  methods: {
    async initUserInfo () {
      this.loading = true
      const res = await this.getUserInfo()
      this.loading = false
      if (res.status) {
        this.userInfo = res.data
        for (let index = 0; index < this.userInfo.permissions.length; index++) {
          if (this.userInfo.permissions[index].priority === 0) {
            this.priorityUser = this.userInfo.permissions[index].priority
          }
        }
      } else {
        this.antmessage.error(res.message)
      }
    },
    async init () {
      this.items = []
      this.loading = true
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      const payload = {
        keyword: this.keyword,
        page: this.pagination.page,
        row: this.pagination.row
      }
      const res = await this.getHospitalForTable(payload)
      this.loading = false
      if (res.status) {
        this.items = res.data.data
        this.pagination = res.data.pagination
      } else {
        this.antmessage.error(res.message)
      }
    },
    click (e) {
      this.$router
        .push({
          name: 'hospitalDashboard',
          params: { hospital_id: e.hospital_id }
        })
        .catch(() => {})
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.$swal({
        allowEnterKey: false,
        title: `ลบ${this.NameComponent}`,
        text: `คุณต้องการลบ${this.NameComponent}นี้ใช่หรือไม่`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.antmessage.loading('กำลังดำเนินการ', 0)
          const payload = { hospital_id: item.hospital_id }
          const res = await this.deleteHospital(payload)
          this.antmessage.destroy()
          if (res.status) {
            this.init()
            this.$swal({
              allowEnterKey: false,
              title: 'สำเร็จ',
              text: `ลบ${this.NameComponent}สำเร็จ`,
              icon: 'success',
              showConfirmButton: false,
              showCancelButton: false,
              timer: 3000
            })
          } else {
            this.antmessage.error(res.message)
          }
        }
      })
    },

    close () {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.bizIdEdit = ''
      })
    },

    onChangePagination (val) {
      this.pagination.page = val.page
      this.pagination.row = val.row
      this.init()
    },

    save () {
      if (this.editedIndex > -1) {
        // TODO Update Data
        this.$swal({
          allowEnterKey: false,
          title: `แก้ไข${this.NameComponent}`,
          text: `คุณต้องการแก้ไข${this.NameComponent}นี้ใช่หรือไม่`,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingSave = true
            const payload = {
              hospital_id: this.editedItem.hospital_id,
              name: this.editedItem.name,
              biz_id: this.editedItem.biz_id,
              // phone: this.editedItem.phone,
              hcode: this.editedItem.hcode,
              province: this.editedItem.province,
              district: this.editedItem.district,
              area: this.editedItem.area,
              description: this.editedItem.description
            }
            const res = await this.updateHospital(payload)
            this.loadingSave = false
            if (res.status) {
              this.init()
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: `แก้ไข${this.NameComponent}สำเร็จ`,
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        })
      } else {
        // TODO Create Data
        this.$swal({
          allowEnterKey: false,
          title: `เพิ่ม${this.NameComponent}`,
          text: `คุณต้องการเพิ่ม${this.NameComponent}นี้ใช่หรือไม่`,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingSave = true
            const res = await this.createHospital(this.editedItem)
            // this.loadingSave = false
            if (res.status) {
              // TODO when get data success
              this.init()
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: `เพิ่ม${this.NameComponent}สำเร็จ`,
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.close()
            } else {
              // TODO when get data fail
              this.antmessage.error(res.message)
            }
          }
        })
      }
    }
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? `เพิ่ม${this.NameComponent}`
        : `แก้ไข${this.NameComponent}`
    },
    formSubTitle () {
      return this.editedIndex === -1
        ? `กรอกข้อมูลเพื่อสร้าง${this.NameComponent}`
        : `กรอกข้อมูลเพื่อแก้ไข${this.NameComponent}`
    }
  }
}
</script>

<style lang="css" scoped>
/* // TODO สำหรับจัดการ Content ของเพจ */
.layout-content {
  height: calc(100% - 58px);
  padding: 0;
  margin: 0;
  /* background: green; */
}

.header-custom-table .header-custom-search {
  display: flex;
  gap: 1rem;

  /* background: gray; */
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}

.header-custom-table .header-custom-actions {
  display: flex;
  gap: 1rem;
  /* background: gray; */
  align-items: center;
  height: 100%;
  min-height: 70px;

  /* justify-content: flex-end; */
}

.main-layout {
  height: calc(100% - 58px);
}
</style>
